import { Action } from '@ngrx/store';
import { AuthData } from '../auth-data.model';

export const DO_AUTO_LOGIN_SUCCESS = '[Auth] Do Auto Login Success';
export const DO_AUTO_LOGIN_FAIL = '[Auth] Do Auto Login Fail';

export const DO_LOGIN = '[Auth] Do Login';
export const DO_LOGIN_SUCCESS = '[Auth] Do Login Success';
export const DO_LOGIN_FAIL = '[Auth] Do Login Fail';

export const DO_LOGOUT = '[Auth] Do Logout';
export const DO_LOGOUT_SUCCESS = '[Auth] Do Logout Success';
export const DO_LOGOUT_FAIL = '[Auth] Do Logout Fail';

export const RESET_EMAIL_DRIVE = '[Auth] Reset Email Drive';
/**
 * Login Actions
 */



export class DoAutoLoginSuccessAction implements Action {
    type = DO_AUTO_LOGIN_SUCCESS;
    constructor(public payload: AuthData) { }
}

export class DoAutoLoginFailAction implements Action {
    type = DO_AUTO_LOGIN_FAIL;
    constructor(public payload: any = null) { }
}

export class DoLoginAction implements Action {
    type = DO_LOGIN;
    constructor(public payload: { username: string, password: string }) { }
}

export class DoLoginSuccessAction implements Action {
    type = DO_LOGIN_SUCCESS;
    constructor(public payload: AuthData) { }
}

export class DoLoginFailAction implements Action {
    type = DO_LOGIN_FAIL;
    constructor(public payload: any = null) { }
}

/**
 * Logout Actions
 */
export class DoLogoutAction implements Action {
    type = DO_LOGOUT;
    constructor(public payload: any = null) { }
}

export class DoLogoutSuccessAction implements Action {
    type = DO_LOGOUT_SUCCESS;
    constructor(public payload: any = null) { }
}

export class DoLogoutFailAction implements Action {
    type = DO_LOGOUT_FAIL;
    constructor(public payload: any = null) { }
}

export class ClearOrUpdateEmailDriveAction  implements Action {
     type = RESET_EMAIL_DRIVE;
    constructor(public payload:string) { }
}

export type AuthActionsAll
    = DoLoginAction
    | DoLoginSuccessAction
    | DoLoginFailAction
    | DoLogoutAction
    | DoLogoutSuccessAction
    | DoLogoutFailAction
    | DoAutoLoginSuccessAction
    | DoAutoLoginFailAction
    | ClearOrUpdateEmailDriveAction 